import { Box, Group, Tooltip } from '@mantine/core';

interface FieldConnectionIndicatorsProps {
  wiuzId?: number | null;
  jdId?: number | null;
}

export function FieldConnectionIndicators({
  wiuzId,
  jdId,
}: FieldConnectionIndicatorsProps) {
  const hasWiuzConnection = wiuzId != null;
  const hasJdConnection = jdId != null;

  if (!hasWiuzConnection && !hasJdConnection) {
    return null;
  }

  return (
    <Group
      gap={4}
      wrap="nowrap"
      component="span"
      style={{
        position: 'absolute',
        right: '0',
        top: '50%',
        transform: 'translateY(-50%)',
        flexShrink: 0,
        pointerEvents: 'auto',
      }}
    >
      {hasWiuzConnection && (
        <Tooltip label="Vi@Parcelle">
          <Box
            style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: '#228BE6',
              cursor: 'pointer',
              flexShrink: 0,
            }}
          />
        </Tooltip>
      )}
      {hasJdConnection && (
        <Tooltip label="John Deere">
          <Box
            style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: '#3B8927',
              cursor: 'pointer',
              flexShrink: 0,
            }}
          />
        </Tooltip>
      )}
    </Group>
  );
}

